import React from 'react'
import {RiMenu3Fill} from 'react-icons/ri'
import {HiOutlineArrowRight} from 'react-icons/hi'
import {useRouter} from 'next/router';
import {useTranslation} from 'react-i18next';
import _ from 'lodash';

const MobileNavigation = ({
                              showBack,
                              forceBack,
                              showMenu,
                              pageTitle
                          }) => {
    const {t} = useTranslation();
    const router = useRouter()

    const handleClickBack = () => {
        if (!_.isEmpty(forceBack)) {
            router.push(forceBack.url, forceBack.as).then()
        } else {
            router.back()
        }
    }

    const handleClickHome = () => {
        router.push('/', '/', {shallow: true})
    }

    return <div className={`mobile-navigation ${_.isEmpty(pageTitle) ? '' : 'has_title'}`}>

    </div>
}

export default MobileNavigation